@for (oneRecord of data; track oneRecord) {
  <p class="accountInfoBorder">{{oneRecord.key}}</p>
  @for (accountText of oneRecord.value; track accountText; let p = $index) {
    <div class="subUniqueTitle d-flex"><div>{{(p+1)}}.</div><div class="auto long-text-cut">{{accountText}}</div></div>
  }
}
